

























































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'
import { DictRequest, DictParam, DictOptions, DictFilter } from '@/types'
import moment from 'moment'

@Component({
  name: 'CalendarSchedule',
  components: {
    DictForm: () =>
      import(/* webpackChunkName: "DictForm" */ '@/components/DictForm.vue')
  }
})
export default class CalendarSchedule extends Vue {
  idxT = -1
  showT = false
  searchT = ''
  idxS = -1
  showS = false
  searchS = ''
  idxTS = -1
  showTS = false
  filter = ''
  filterType = 0
  currentItem = undefined
  tableHeight: number | string = 0
  saveForm = false
  needUpdateTable = false
  dictSheaders = [
    {
      text: 'Название',
      value: 'name'
    },
    {
      source: 'GraphWork',
      sourcetext: 'Name',
      sourcevalue: 'rejim',
      text: 'Режим',
      type: 'select',
      value: 'rejim'
    },
    {
      text: '',
      value: 'action',
      width: '80'
    }
    // {
    //   "text": "Сменность",
    //   "type": "switch",
    //   "value": "shifting"
    // },
    // {
    //   "text": "Начало смены 1",
    //   "type": "time",
    //   "value": "shift1"
    // },
    // {
    //   "text": "Продолжительность смены 1",
    //   "type": "time",
    //   "value": "shift1len"
    // },
    // {
    //   "text": "Обед смены 1",
    //   "type": "time",
    //   "value": "shift1dinner"
    // },
    // {
    //   "text": "Начало смены 2",
    //   "type": "time",
    //   "value": "shift2"
    // },
    // {
    //   "text": "Продолжительность смены 2",
    //   "type": "time",
    //   "value": "shift2len"
    // },
    // {
    //   "text": "Обед смены 2",
    //   "type": "time",
    //   "value": "shift2dinner"
    // }
  ]

  mounted () {
    this.idxT = EPLModule.DictIdx('Transport')
    this.idxS = EPLModule.DictIdx('WorkSchedule')
    this.idxTS = EPLModule.DictIdx('TransportShifts')
    this.reSize()
    window.addEventListener('resize', this.reSize)
    this.getData()
  }

  get dictT () {
    return EPLModule.dicts[this.idxT]
  }

  get dictS () {
    return EPLModule.dicts[this.idxS]
  }

  get dictTS () {
    return EPLModule.dicts[this.idxTS]
  }

  get isShowForm () {
    if (!this.dictS.isShowForm) {
      if (this.needUpdateTable) {
        this.needUpdateTable = false
        this.getData()
      }
    }
    return this.dictS.isShowForm
  }

  public updateTable () {
    this.needUpdateTable = true
  }

  private getData () {
    const p = {} as DictParam
    p.idx = this.idxT
    p.request = {} as DictRequest
    p.request.options = {} as DictOptions
    p.request.options.page = 1
    p.request.options.itemsPerPage = -1
    EPLModule.fetchDictData(p)
      .then(() => {
        this.showT = true
      })
    const ps = {} as DictParam
    ps.idx = this.idxS
    ps.request = {} as DictRequest
    ps.request.options = {} as DictOptions
    ps.request.options.page = 1
    ps.request.options.itemsPerPage = -1
    // p.idx = this.idxS
    EPLModule.fetchDictData(ps)
      .then(() => {
        this.showS = true
      })
    this.filterTS('', 0)
  }

  private filterTS (item: any, type: number) {
    this.filterType = type
    const pts = {} as DictParam
    pts.idx = this.idxTS
    pts.request = {} as DictRequest
    pts.request.options = {} as DictOptions
    pts.request.options.page = 1
    pts.request.options.itemsPerPage = -1
    if (type === 0) {
      pts.request.filter = []// as Array<DictFilter>
      pts.request.filter.push({
        field: 'id',
        condition: '0',
        operator: '=',
        combine: 'AND'
      })
      this.filter = 'Претащите сюда "Режим" или "ТС" для фильтрации'
      this.currentItem = undefined
    }
    if (type === 1) {
      pts.request.filter = []// as Array<DictFilter>
      pts.request.filter.push({
        field: 'workscheduleid',
        condition: `${item.id}`,
        operator: '=',
        combine: 'AND'
      })
      this.filter = `Режим : ${item.rejim}`
      this.currentItem = item
    }
    if (type === 2) {
      pts.request.filter = []// as Array<DictFilter>
      pts.request.filter.push({
        field: 'transportid',
        condition: `${item.uid}`,
        operator: '=',
        combine: 'AND'
      })
      this.filter = `ТC: ${item.marka} - ${item.gosnumber}`
      this.currentItem = item
    }
    EPLModule.fetchDictData(pts)
      .then(() => {
        this.showTS = true
      })
  }

  private editItemS (id: number) {
    EPLModule.showDictForm({ id: id, idx: this.idxS })
  }

  private addTS (item: any, type: number) {
    if (type === 0) {
      return
    }
    if (type === 1) {
      this.dictTS.currentRow.id = 0
      this.dictTS.currentRow.transportid = this.currentItem.uid
      this.dictTS.currentRow.workscheduleid = item.id
    }
    if (type === 2) {
      this.dictTS.currentRow.id = 0
      this.dictTS.currentRow.transportid = item.uid
      this.dictTS.currentRow.workscheduleid = this.currentItem.id
    }
    EPLModule.saveDictCurrentRow({ idx: this.idxTS, hide: false })
      .then(() => {
        let t = 0
        if (type === 1) t = 2
        if (type === 2) t = 1
        this.filterTS(this.currentItem, t)
      })
  }

  isInTable (item: any): boolean {
    let res = false
    this.dictTS.rows.forEach(r => {
      if (this.filterType === 2) {
        if (r.workscheduleid === item.id) {
          res = true
        }
      }
      if (this.filterType === 1) {
        if (r.transportid === item.uid) {
          res = true
        }
      }
    })
    return res
  }

  private move (item: any) {
    const self = this
    if (event === undefined) return
    let ev = null
    ev = event as MouseEvent

    if (ev === null || ev.target === null) return
    const target = ev.target as Element
    const object = document.createElement('span')
    let type = 0
    let name = item.name
    if (name === undefined) {
      name = `Гос. номер ТС: ${item.gosnumber}`
      type = 2
    } else {
      name = `Режим: ${item.name}`
      type = 1
    }
    object.className = 'v-chip v-chip--no-color theme--light v-size--default'
    object.innerHTML =
      '<span class="v-chip__content">' + name + '</span>'

    const shiftX = ev.clientX - target.getBoundingClientRect().left
    const shiftY = ev.clientY - target.getBoundingClientRect().top

    object.style.pointerEvents = 'none'
    object.style.position = 'absolute'
    object.style.zIndex = '1000'
    document.body.append(object)

    function moveAt (pageX: number, pageY: number) {
      object.style.left = pageX - shiftX + 'px'
      object.style.top = pageY - shiftY + 'px'
    }

    moveAt(ev.pageX, ev.pageY)

    let dropelement: HTMLElement
    let canFilter = false
    let canTable = false
    let currentDroppableF: HTMLElement | null
    let currentDroppableT: HTMLElement | null

    function onMouseMove (event: MouseEvent) {
      moveAt(event.pageX, event.pageY)
      const elemBelow = document.elementFromPoint(event.clientX, event.clientY)
      if (!elemBelow) return
      function leaveFilter (elem: HTMLElement) {
        canFilter = false
        elem.style.background = ''
      }
      function enterFilter (elem: HTMLElement) {
        dropelement = elem
        canFilter = true
        elem.style.background = '#00a2a5'
      }
      function enterTable (elem: HTMLElement) {
        dropelement = elem
        if (self.filterType === 0) {
          canTable = false
          elem.style.background = '#ff4000'
        } else {
          if ((type === 1 && self.filterType === 2) || (type === 2 && self.filterType === 1)) {
            if (self.isInTable(item)) {
              canTable = false
              elem.style.background = '#ff4000'
            } else {
              canTable = true
              elem.style.background = '#00a2a5'
            }
          } else {
            canTable = false
            elem.style.background = '#ff4000'
          }
        }
      }
      function leaveTable (elem: HTMLElement) {
        canTable = false
        elem.style.background = ''
      }

      const filterBelow: HTMLElement | null = elemBelow.closest('.filter')
      if (currentDroppableF !== filterBelow) {
        if (currentDroppableF) {
          leaveFilter(currentDroppableF)
        }
        currentDroppableF = filterBelow
        if (currentDroppableF) {
          enterFilter(currentDroppableF)
        }
      }
      const tableBelow: HTMLElement | null = elemBelow.closest('.table')
      if (currentDroppableT !== tableBelow) {
        if (currentDroppableT) {
          leaveTable(currentDroppableT)
        }
        currentDroppableT = tableBelow
        if (currentDroppableT) {
          enterTable(currentDroppableT)
        }
      }
    }

    function onMouseUp () {
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
      if (dropelement !== undefined) {
        dropelement.style.background = ''
        if (canFilter) {
          self.filterTS(item, type)
        }
        if (canTable) {
          self.addTS(item, type)
        }
      }
      object.onmouseup = null
      object.remove()
    }

    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)

    object.ondragstart = function () {
      return false
    }
  }

  private deleteItem (item: any): void {
    if (confirm('Удалить запись?')) {
      EPLModule.delDictRow({ id: item.id, idx: this.idxTS })
    }
  }

  private deleteItemS (item: any): void {
    if (confirm('Удалить запись?')) {
      EPLModule.delDictRow({ id: item.id, idx: this.idxS })
    }
  }

  private deleteItemT (item: any): void {
    if (confirm('Удалить запись?')) {
      EPLModule.delDictRow({ id: item.id, idx: this.idxT })
    }
  }

  private correctDate (date: number) {
    return moment.unix(date).format('DD.MM.YYYY HH:mm')
  }

  private getSelectValue (value: string | number, list: any): string {
    let result = ''
    if (EPLModule.lists[list]) {
      EPLModule.lists[list].forEach((i: any) => {
        if (i.value === value || i.value === `${value}`) {
          result = i.text
        }
      })
    }
    return result
  }

  private getTimeFormat (sec: number) {
    const h = Math.trunc(sec / 60)
    const m = sec - h * 60
    let ht = `${h}`
    if (h < 10) ht = '0' + h
    let mt = `${m}`
    if (m < 10) mt = '0' + m
    return `${ht}:${mt}`
  }

  private reSize () {
    const k = 300
    this.tableHeight = window.innerHeight - k
  }
}
